import {Injectable} from '@angular/core';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {MatDialog} from '@angular/material/dialog';
import {Product} from '@app/core/product/domain/dtos/product';
import {take} from 'rxjs/operators';
import {DisplayService} from '../display.service';
import {NoStockBottomSheetComponent} from './no-stock-bottom-sheet/no-stock-bottom-sheet.component';
import {NoStockModalComponent} from './no-stock-modal/no-stock-modal.component';

@Injectable()
export class NoStockService {

  constructor(
    private displayService: DisplayService,
    private bottomSheet: MatBottomSheet,
    private matDialog: MatDialog
  ) { }

  /**
   * If the user is on a mobile device, open a bottom sheet, otherwise open a dialog
   * @param {Product[]} products - The products to display in the component
   */
  display(products: Product[]) {
    this.displayService.isMobileDisplay$
      .pipe(take(1))
      .subscribe({
        next: isMobile => {
        if (isMobile) {
          this.openBottomSheet(products);
        } else {
          this.openDialog(products)
        }
      }})
  }

  private openBottomSheet(products: Product[]) {
    this.bottomSheet.open(NoStockBottomSheetComponent, {
      panelClass: 'ep-bottom-sheet',
      data: { products: products },
    })
  }

  private openDialog(products: Product[]) {
    this.matDialog.open(NoStockModalComponent, {
      panelClass: 'custom-modal-container',
      data: { products: products },
    })
  }
}
